module.exports = __webpack_public_path__ + "static/media/netsuite.d5c8334d.png";